// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// RasPm Dashboard components
import MDTypography from "components/MDTypography";

// RasPm Dashboard base styles
import typography from "assets/theme/base/typography";
import { Directions } from "@mui/icons-material";

function Footer({ company, links }) {
  const { href, name } = company;
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <div key={link.name} style={{ padding: "0 1rem", lineHeight: 1 }}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </MDTypography>
        </Link>
      </div>
    ));

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 1.5rem",
        direction: "ltr",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          color: "#666666",
          fontSize: size.sm,
          padding: "0 1.5rem",
          direction: "ltr",
        }}
      >
        Copyright &copy; {new Date().getFullYear()} Smart Oasis. All rights reserved.
        by
        <Link href={href} target="_blank">
          <MDTypography variant="button" fontWeight="medium" sx={{ color: "#666666" }}>
            &nbsp;{name}&nbsp;
          </MDTypography>
        </Link>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          marginTop: "1.5rem",
          marginBottom: 0,
          padding: 0,
          direction: "rtl",
          [`@media (min-width: 1200px)`]: {
            marginTop: 0,
          },
        }}
      >
        {renderLinks()}
      </div>
    </div>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "https://www.soc.iq/", name: "Smart Oasis" },
  links: [
    // { href: "https://www.smartoasis.iq/", name: "Smart Oasis" },
    // { href: "https://www.smartoasis.iq/presentation", name: "About Us" },
    // { href: "https://www.smartoasis.iq/blog", name: "Blog" },
    // { href: "https://www.smartoasis.iq/license", name: "License" },
  ],
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
